/** @type {import('../help-index.js').HelpSidebarItem} */
export const FIN_OCC_CARDS_ITEM = {
  id: 'cards',
  screenId: 'fin-occ-cards',
  label: 'Tarjetas',
  description: 'Alta y edición de tarjetas corporativas de la empresa.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'Registrá las tarjetas de crédito o débito que usa la empresa para pagar gastos. Cada tarjeta define moneda, banco de pago del resumen y días de cierre y vencimiento.',
      },
      {
        title: 'Antes de empezar',
        paragraphs: [
          'Conviene tener cuentas bancarias cargadas en Finanzas → Bancos.',
          'Emisor y marca usan el mismo catálogo que Finanzas → Tarjetas → Configuración (proveedores y marcas).',
          'Los consumos se registran después en Pagos con medio «tarjeta propia»; acá solo configurás la tarjeta.',
        ],
      },
      {
        title: 'Paso 1 — Ver la lista',
        bullets: [
          'Columnas: Descripción, Moneda, Banco de pago, Cierre (día del mes), Vencimiento (día del mes).',
          'Tocá el lápiz en la fila para editar (si tenés permiso de modificación).',
          'Podés exportar la lista.',
        ],
      },
      {
        title: 'Paso 2 — Nueva tarjeta',
        intro: 'El botón + abre el formulario. Campos:',
        fields: [
          { label: 'Descripción', description: 'Nombre interno obligatorio (por ejemplo «Visa corporativa gerencia»). No puede repetirse.' },
          { label: 'Moneda', description: 'Obligatoria al crear. No se puede cambiar después en la edición.' },
          { label: 'Emisor', description: 'Opcional. Procesadora o banco emisor (catálogo de proveedores de tarjetas).' },
          { label: 'Marca', description: 'Opcional. Visa, Mastercard, etc. (catálogo de marcas).' },
          { label: 'Banco desde el que se paga el resumen', description: 'Opcional. Cuenta bancaria habitual para pagar el resumen.' },
          { label: 'Día de cierre / Día de vencimiento', description: 'Opcionales. Números del 1 al 31 según el ciclo de la tarjeta.' },
        ],
        paragraphs: [
          'Quien crea la tarjeta queda autorizado a usarla. Tocá «Guardar» para confirmar.',
        ],
      },
      {
        title: 'Paso 3 — Editar',
        bullets: [
          'Podés cambiar descripción, emisor, marca, banco de pago y días de cierre/vencimiento.',
          'La moneda queda fija desde el alta.',
          'Casilla «Activa» — desmarcá para dejar de usar la tarjeta sin borrar el historial.',
        ],
      },
    ],
  },
}
